import { types } from "mobx-state-tree";
import { DefaultPinnedApps } from "Apps/AppRegistryEnvs";

export const UserAppHubSettings = types
    .model("userAppHubSetting", {
        appIds: types.optional(types.array(types.string), []),
        unPinnedDefaultIds: types.optional(types.array(types.string), []),
        onListView: types.optional(types.boolean, true)
    })
    .views((self) => ({
        get defaultPinnedApps(): string[] {
            return DefaultPinnedApps.filter((i) => !self.unPinnedDefaultIds.includes(i));
        },
        get allPinnedApps() {
            const defaultPinnedApps = this.defaultPinnedApps;
            const userPinnedApps = self.appIds.filter((id) => !defaultPinnedApps.includes(id));
            return [...defaultPinnedApps, ...userPinnedApps];
        },
        isPinned(appId?: string) {
            if (!appId) {
                return false;
            }
            return self.appIds.includes(appId) || this.defaultPinnedApps.includes(appId);
        }
    }))
    .actions((self) => ({
        unpinApp(appId: string) {
            remove(self.appIds, appId);
            if (self.defaultPinnedApps.includes(appId)) {
                add(self.unPinnedDefaultIds, appId);
            }
        },
        pinApp(appId: string) {
            const isDefaultPinnedApp = DefaultPinnedApps.find((i) => i === appId);
            if (isDefaultPinnedApp) {
                remove(self.unPinnedDefaultIds, appId);
            } else {
                add(self.appIds, appId);
            }
        },
        toggleView(onListView: boolean) {
            self.onListView = onListView;
        }
    }));

function add(appIds: string[], appId: string) {
    const app = appIds.find((i) => i === appId);
    if (!app) {
        appIds.push(appId);
    }
}

function remove(appIds: string[], appId: string) {
    const appIndex = appIds.indexOf(appId);
    if (appIndex > -1) {
        appIds.splice(appIndex, 1);
    }
}
